/* eslint-disable prettier/prettier */
/* eslint-disable import/named */
import "../../styles/DashboardPage.scss";
import "../../styles/DashboardPageV2.scss";
import "../../styles/Ticker.scss";
import {
  FirebaseReducer,
  getFirebase,
  isLoaded
} from "react-redux-firebase";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { checkSquare, download, mail, phone, power, refreshCw, search, settings, xCircle } from "react-icons-kit/feather";
import { connect } from "react-redux";
import {
  downloadAdminClaimDetailCsv,
  getAdminDashboardStats,
  getLatestClaimNotes
} from "../../actions/update-claim";
import { getNewsFeed } from "../../actions/new-claim";
import Helmet from "react-helmet";
import Icon from "react-icons-kit";
import InfoPanel from "../modals/infopanel/InfoPanel";
import LoadingPage from "../loading/LoadingPage";
import NewsTicker from "../newsFeed/NewsTicker/index";
import React, { Component } from "react";
import Ticker from "../newsFeed/Ticker/index";
import dashIncomingIcon from "../../images/svg-files/dash-incoming.svg";
import dashOutgoingIcon from "../../images/svg-files/dash-outgoing.svg";
import moment from "moment";

interface AdminDashboardProps extends RouteComponentProps {
  auth: FirebaseReducer.AuthState;
  profile: FirebaseReducer.Profile;
  loading: boolean;
  firebase: any;
  searchChange?: (value: string) => void;
}

interface AdminDashboardStats {
  totalClaims: number;
  totalWithoutCancel: number;
  completedCount: number;
  cancelledCount: number;
  invoicedCount: number;
  topClaimsSent: string[];
  topClaimsReceived: string[];
}

interface AdminDashboardState {
  news: any[] | null;
  latestNotes: any[];
  searchValue: string;
  searchError: string;
  infoPanelOpen: boolean;
  downloadReportLoading: boolean;
  stats: AdminDashboardStats | null;
  statsLoading: boolean;
}

class AdminDashboardPage extends Component<AdminDashboardProps, AdminDashboardState> {
  private adminDataRequested = false;

  state: AdminDashboardState = {
    news: null,
    latestNotes: [],
    searchValue: "",
    searchError: "",
    infoPanelOpen: false,
    downloadReportLoading: false,
    stats: null,
    statsLoading: true
  };

  componentDidMount() {
    this.loadAdminDataIfAllowed();
  }

  componentDidUpdate(prevProps: AdminDashboardProps) {
    if (prevProps.profile !== this.props.profile) {
      this.loadAdminDataIfAllowed();
    }
  }

  private loadAdminDataIfAllowed = () => {
    const { profile } = this.props;
    if (!isLoaded(profile) || this.adminDataRequested) return;

    if ((profile as any)?.partnerId !== "Admin") {
      this.setState({ statsLoading: false });
      return;
    }

    this.adminDataRequested = true;
    this.loadNews();
    this.loadStats();
    this.loadLatestNotes();
  };

  private loadNews = async () => {
    try {
      const response: any = await getNewsFeed();
      const rows = response?.newsFeedData?.data;
      this.setState({ news: Array.isArray(rows) ? rows : [] });
    } catch (error) {
      console.error(error);
      this.setState({ news: [] });
    }
  };

  private loadStats = async () => {
    try {
      const stats = await getAdminDashboardStats();
      this.setState({ stats, statsLoading: false });
    } catch (error) {
      console.error(error);
      this.setState({ stats: null, statsLoading: false });
    }
  };

  private loadLatestNotes = async () => {
    try {
      const notes = await getLatestClaimNotes(4, "Admin");
      this.setState({ latestNotes: Array.isArray(notes) ? notes : [] });
    } catch (error) {
      console.error(error);
      this.setState({ latestNotes: [] });
    }
  };

  private handleSearchValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchValue: event.target.value, searchError: "" });
  };

  private handleDashboardSearch = () => {
    const searchValue = this.state.searchValue.trim();
    if (!searchValue) {
      this.setState({ searchError: "Enter a claim number or license plate" });
      return;
    }
    if (this.props.searchChange) this.props.searchChange(searchValue);
    this.props.history.push("/all");
  };

  private handleSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleDashboardSearch();
    }
  };

  private formatCount = (count: number): string => {
    if (count >= 1000000) return `${Math.floor(count / 1000000)}m`;
    if (count >= 1000) return `${Math.floor(count / 1000)}k`;
    return String(count);
  };

  private exportToCsv = (filename: string, rows: any[]): void => {
    if (!rows || !rows.length) return;
    const headerList = [
      "Claim Id", "Claim Number", "Origin Member", "Destination Member", "Status",
      "Cancelled by", "Cancelled Reason", "Calibration Certificate", "Incident Type",
      "Cause Of Loss", "Glass Position", "Created On", "Proof Of Payment", "Contact Client",
      "Book In Date", "Confirm Estimate", "Complete Fitment", "Vehicle Images",
      "Calibration Certificate", "Collected Excess", "Invoice", "Ratings Destination Created",
      "Ratings Destination Updated", "Rated By Destination Member", "Rated By Destination User",
      "Rated On Destination", "Rating Destination", "Reason Destination",
      "Rated By Origin Member Rating Member", "Rated By Origin Member Rating User",
      "Rated On Origin Member Rating", "Rating Origin Member Rating", "Reason Origin Member Rating"
    ];
    const csvContent = "sep=,\n" + headerList.join(",") + "\n" +
      rows.map(row => row === null || row === undefined ? "" : row).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  private handleDownloadReport = async () => {
    if (this.state.downloadReportLoading) return;
    this.setState({ downloadReportLoading: true });
    try {
      const response = await downloadAdminClaimDetailCsv();
      if (response !== undefined && response[0]) {
        this.exportToCsv("AllClaimDetails.csv", response[0] as any[]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ downloadReportLoading: false });
    }
  };

  render() {
    const { auth, profile, loading } = this.props;
    if (isLoaded(profile) && (profile as any)?.partnerId !== "Admin") return <Redirect to="/" />;
    if (loading || this.state.statsLoading) return <LoadingPage />;

    const stats = this.state.stats || {
      totalClaims: 0,
      totalWithoutCancel: 0,
      completedCount: 0,
      cancelledCount: 0,
      invoicedCount: 0,
      topClaimsSent: [],
      topClaimsReceived: []
    };
    const { downloadReportLoading } = this.state;
    const updates = this.state.latestNotes.length
      ? this.state.latestNotes.map((item: any, index: number) => ({
          id: item?.id || index,
          title: item?.note || "No note available",
          meta: `${item?.createdOn ? `${moment(item.createdOn).format("DD/MM/YYYY")} - ` : ""}${item?.claimNumber || "Unknown Claim"}`
        }))
      : [{ id: "empty", title: "No recent notes", meta: "No claim notes found" }];
    const tickerItems: any[] = [];

    (this.state.news || []).forEach((item: any, index: number) => {
      try {
        const createdDate = moment(item[0]._audit.created.timestamp).utc().format("DD/MM/YYYY");
        tickerItems.push(
          <NewsTicker key={index} id={index + 1} title={`${item[0].news.news} By Admin `} meta={createdDate} url="" />
        );
      } catch (error) {
        // Ignore malformed news entries without breaking the dashboard.
      }
    });

    const metrics: any[] = [
      ["metric-without-cancel-v2", checkSquare, "Total Claims without Cancelations", stats.totalWithoutCancel],
      ["metric-completed-v2", settings, "Completed Services", stats.completedCount],
      ["metric-cancelled-v2", xCircle, "Total Cancelations", stats.cancelledCount],
      ["metric-total-v2", refreshCw, "Total Claims", stats.totalClaims]
    ];
    const topLists: any[] = [
      ["Claims Sent", "Top 3 Claims Sent", dashOutgoingIcon, stats.topClaimsSent],
      ["Claims Received", "Top 3 Received", dashIncomingIcon, stats.topClaimsReceived]
    ];

    return (
      <div className="dashboard-page-container-v2 admin-dashboard-v2">
        <Helmet><meta charSet="utf-8" /><title>AGE | Admin Dashboard</title></Helmet>
        <div className="dashboard-v2-layout admin-layout-v2">
          <section className="dashboard-main-v2">
            <header className="dashboard-header-v2">
              <h1>Group Growth</h1>
              <div className="download-wrapper-v2">
                <span className="download-label-v2">
                  {downloadReportLoading ? <>Downloading<br />report...</> : <>Download full<br />report</>}
                </span>
                <button className="download-btn-v2" type="button" onClick={this.handleDownloadReport}
                  disabled={downloadReportLoading} aria-busy={downloadReportLoading}>
                  <Icon icon={downloadReportLoading ? refreshCw : download} size={24} />
                </button>
              </div>
            </header>
            <div className="growth-card-v2">
              <div className="growth-grid-v2">
                {metrics.map(([className, icon, label, value]) => (
                  <div className={`metric-block-v2 ${className}`} key={label}>
                    <div className="metric-icon-v2"><Icon icon={icon} size={22} /></div>
                    <div className="metric-copy-v2"><p className="metric-title-v2">{label}</p><h3>{this.formatCount(value)}</h3></div>
                  </div>
                ))}
                <div className="metric-block-v2 metric-invoiced-v2">
                  <div className="metric-icon-v2 euro-icon-v2"><span>€</span></div>
                  <div className="metric-copy-v2"><p className="metric-title-v2">Invoiced <br />Services</p><h3>{this.formatCount(stats.invoicedCount)}</h3></div>
                </div>
              </div>
              <div className="growth-divider-v2" />
              <div className="top-list-grid-v2">
                {topLists.map(([alt, label, icon, members]) => (
                  <div className="top-list-block-v2" key={label}>
                    <div className="metric-icon-v2 small"><img src={icon} alt={alt} /></div>
                    <div><p className="metric-title-v2">{label}</p><ol>
                      {(members.length ? members : ["No claims found"]).map((name: string, index: number) => <li key={`${label}-${index}`}>{name}</li>)}
                    </ol></div>
                  </div>
                ))}
              </div>
              <div className="watermark-v2"><div>{moment().format("MMM").toUpperCase()}</div><div>{moment().format("DD")}</div></div>
            </div>
          </section>
          <aside className="dashboard-aside-v2">
            <div className="user-container-v2">
              <div className="user-info">Hi, {auth.displayName || auth.email}</div>
              <button className="logout-button-v2" onClick={() => this.props.firebase.logout()} title="Logout" type="button">
                <Icon icon={power} size={18} />
              </button>
            </div>

            <div className="search-control">
              <button type="button" className="search-icon-btn" aria-label="Search claim or license plate" onClick={this.handleDashboardSearch}>
                <Icon icon={search} size={22} />
              </button>
              <input className="search-input" placeholder="Search claim or license plate" value={this.state.searchValue}
                onChange={this.handleSearchValueChange} onKeyDown={this.handleSearchKeyDown} />
            </div>
            {this.state.searchError ? <div className="search-feedback-v2">{this.state.searchError}</div> : null}

            <h2 className="updates-title-v2">Last Updates</h2>
            <div className="updates-list-v2">
              {updates.map((update: any) => (
                <div className="update-row-v2" key={`update-${update.id}`}>
                  <div className="update-icon-v2"><Icon icon={mail} size={20} /></div>
                  <div><div className="update-title-v2">{update.title}</div><div className="update-meta-v2">{update.meta}</div></div>
                </div>
              ))}
            </div>

            <button type="button" className="action-btn-v2 contacts-btn-v2" onClick={() => this.setState({ infoPanelOpen: true })}>
              <Icon icon={phone} size={18} /><span>Contacts</span>
            </button>
          </aside>
        </div>
        <InfoPanel isOpen={this.state.infoPanelOpen} toggle={() => this.setState({ infoPanelOpen: false })} initialTab="2" />
        <div className="breaking-news-bar-v2">
          <span className="breaking-news-badge-v2">Breaking News</span>
          <div className="breaking-news-ticker-v2">
            {tickerItems.length ? <Ticker isNewsTicker={true} slideSpeed={25}>
              {tickerItems.map((item, index) => <div key={index} className="news-item">{item}</div>)}
            </Ticker> : <div className="breaking-news-fallback-v2">No news available</div>}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ firebase: { auth, profile } }: any) => ({
  auth,
  profile,
  loading: !isLoaded(profile),
  firebase: getFirebase()
});

const mapDispatchToProps = (dispatch: any) => ({
  searchChange: (value: string) => dispatch({ type: "SEARCH_CHANGE", value })
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboardPage);
